<template>
  <div v-if="showGuestModal">
    <transition name="modal">
      <div class="modal-mask">
        <div class="modal-wrapper">
          <div class="modal-dialog">
            <div class="modal-content">
              <div class="modal-header">
                <div class="modal-title">
                  <button type="button" class="close" @click="closeModal">
                    <span aria-hidden="true">&times;</span>
                  </button>
                  <h3 class="welcome">Enter Your Email to Proceed</h3>
                </div>
              </div>
              <div class="modal-body">
                <div class="row">
                  <div class="col-md-12">
                    <!--REG FORM-->
                    <form @submit.prevent="register" name="form2" class="register-form">
                      <div class="form-group">
                        <label for="email">Email</label>
                        <p class="control has-icon has-icon-right">
                          <input name="email" id="email" v-model="email" v-validate="'required|email'" :class="{'input': true, 'is-danger': errors.has('email') }" class="form-control" type="text" placeholder="Email">
                          <i v-show="errors.has('email')" class="fa fa-warning"></i>
                          <span v-show="errors.has('email')" class="help is-danger">{{ errors.first('email') }}</span>
                        </p>
                      </div>
                      <div class="form-group">
                        <button type="submit" class="btn btn-dark login-button">Continue</button>
                      </div>
                      <div class="form-group">
                        <a href="javascript:" class="register-button" @click="showLogin">Already have an account? <b>Sign In Now</b></a>
                      </div>
                    </form>
                    <!--REG FORM END-->
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
export default {
  name: "GuestModal",
  data() {
    return {
      email: '',
    }
  },
  computed: {
    showGuestModal() {
      return this.$store.state.showGuestModal;
    }
  },
  methods: {
    closeModal() {
      this.$store.commit('showGuestModal',false);
    },
    showLogin() {
      this.closeModal();
      this.$store.commit('showModal',true);
    },
    register(e) {
      e.preventDefault();
      this.$validator.validateAll().then((reg) => {
        if (reg) {
          let random_str = 'guest_'+Math.floor(Math.random() * 10000)+10;
          this.$toaster.success("Guest Login Successful");
          this.$store.commit('showGuestModal',false);
          this.$store.commit('loginStatus',true);
          this.$store.commit('isGuest',true);
          let instance = this;
          this.$store.dispatch('setUser',{
            client_name: 'Guest',
            client_username: random_str,
            receive_time: '',
            status: 'Active',
            user_email: instance.email
          });
          localStorage.setItem('access_token','guest_'+random_str+this.email);
          localStorage.setItem('email',this.email);
          this.email = '';
        }
      });
    }
  },
}
</script>

<style scoped>
.modal-mask {
  position: fixed;
  z-index: 9998;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, .5);
  display: table;
  transition: opacity .3s ease;
}

.modal-wrapper {
  display: table-cell;
  vertical-align: middle;
}

.modal-dialog {
  max-width: 500px !important;
}
.modal-header {
  border: none !important;
  margin-top: 10px;
}
.modal-body {
  padding: 0 30px;
}
.login-button {
  width: 100%;
  margin-top: 10px;
  background: #004a59;
  border: 1px solid #004a59;
}
.register-form {
  margin-bottom: 50px;
}
.register-button {
  width: 100%;
  color: #004a59;
}
.forgot-section {
  float: right;
  margin-bottom: 5px;
}
.forgot-section a {
  color: #1d2124;
  letter-spacing: 0.05em;
}
.forgot-section a:hover {
  color: #000000;
  letter-spacing: 0.05em;
  font-weight: bold;
}
.welcome {
  text-align: center;
  font-weight: bold;
  color: #004a59;
  padding-bottom: 13px;
  border-bottom: 2px solid rgb(27, 118, 187,0.1);
}
.modal-header {
  display: block;
}
.error p,ul > li {
  color: #ee3434;
  margin-left: -22px;
  line-height: 20px;
}
.error ul {
  margin-bottom: 0px;
}
.form-group {
  margin-bottom: 0.4rem;
}
.form-group label {
  margin-bottom: 0.1rem;
}
.is-danger {
  color: #ee3434;
}
.control {
  margin-bottom: 0;
}
</style>